/** Whether a PO carries an estimated package breakdown, and its packages. */
export function estimatedPackages(facts: Record<string, unknown>) {
  const packages = Array.isArray(facts.packages)
    ? facts.packages.filter((item): item is Record<string, unknown> => item != null && typeof item === 'object')
    : []
  const packageCount = Number(facts.physical_package_count)
  return Number.isInteger(packageCount) && packageCount > 0 && packages.length > 0
    ? { packages, packageCount }
    : null
}

/** Whether the PO has an estimated package breakdown to show. */
export function hasEstimatedPackageFacts(facts: Record<string, unknown>) {
  return estimatedPackages(facts) !== null
}
